import {getChangesFields} from '../../../../rest/arguments'
import {getBuildFields} from '../../../../rest/builds'
import type {ChangesRequestOptions, RequestOptionsParams} from '../../../../types'

export const getChangeLogArg = ({
  locator,
  changesOptions,
  buildOptions,
  withGraph,
}: {
  locator: string
  changesOptions?: ChangesRequestOptions
  buildOptions?: RequestOptionsParams
  withGraph?: boolean
}) => ({
  locator,
  fields: `row(${getChangesFields(changesOptions)},build(${getBuildFields(buildOptions)}))${
    withGraph ? ',graph' : ''
  }`,
  withUpdatePager: changesOptions?.withUpdatePager ?? false,
})
